import React from "react";
import { motion } from "framer-motion";
import { Mail, MessageSquare, Send } from "lucide-react";

const Contact = () => {
  return (
    <section
      id="contact"
      className="section-padding section-divider relative overflow-hidden bg-slate-50"
    >
      <div className="absolute inset-0 bg-white/40" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/3 rounded-full blur-[150px] pointer-events-none" />

      <div className="container mx-auto max-w-3xl relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-primary/90 mb-5 border border-primary/15 rounded-full px-4 py-1.5 bg-primary/5">
            Contact Us
          </span>
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-5 tracking-[-0.02em]">
            Let's talk quality
          </h2>
          <p className="text-muted-foreground leading-relaxed font-light">
            Have questions? We'd love to hear from you.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="glass rounded-2xl p-8 md:p-12 card-hover gradient-border"
        >
          <form className="space-y-7" onSubmit={(e) => e.preventDefault()}>
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="text-sm font-medium text-foreground/90 mb-2.5 block tracking-wide">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Your name"
                  className="w-full bg-white border border-border rounded-xl px-4 py-3.5 text-sm text-foreground shadow-sm placeholder:text-muted-foreground/50 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-foreground/90 mb-2.5 block tracking-wide">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="you@company.com"
                  className="w-full bg-white border border-border rounded-xl px-4 py-3.5 text-sm text-foreground shadow-sm placeholder:text-muted-foreground/50 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300"
                />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium text-foreground/90 mb-2.5 block tracking-wide">
                Message
              </label>
              <textarea
                rows={5}
                placeholder="How can we help?"
                className="w-full bg-white border border-border rounded-xl px-4 py-3.5 text-sm text-foreground shadow-sm placeholder:text-muted-foreground/50 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300 resize-none"
              />
            </div>
            <button
              type="submit"
              className="group w-full inline-flex items-center justify-center gap-2.5 bg-primary text-primary-foreground font-semibold py-4 rounded-xl hover:shadow-lg hover:shadow-primary/30 transition-all duration-300 text-sm"
            >
              Send Message
              <Send
                size={14}
                className="group-hover:translate-x-1 transition-transform duration-300"
              />
            </button>
          </form>

          <div className="mt-10 pt-8 border-t border-border/30 flex flex-col sm:flex-row items-center justify-center gap-8 text-sm text-muted-foreground">
            <a
              href="mailto:hello@qa-path.com"
              className="flex items-center gap-3 hover:text-foreground transition-colors duration-300"
            >
              <div className="w-9 h-9 rounded-xl bg-primary/8 flex items-center justify-center">
                <Mail size={14} className="text-primary" />
              </div>
              <span>hello@qa-path.com</span>
            </a>
            <a
              href="https://cal.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 hover:text-foreground transition-colors duration-300"
            >
              <div className="w-9 h-9 rounded-xl bg-primary/8 flex items-center justify-center">
                <MessageSquare size={14} className="text-primary" />
              </div>
              <span>Book a strategy call</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;

